import { IMatrixCreationParameters, IMatrixCreationResult, MatrixCreationType } from '../matrix-creation-interfaces';
import {
    euclideanDistance,
    getPointString,
    manhattanDistance,
    manhattanDistanceExplanation
} from '../../cluster-provider';

export const createMatrix = (params: IMatrixCreationParameters, type: MatrixCreationType) : IMatrixCreationResult|null => {
    switch (type) {
        case MatrixCreationType.RatioOfMismatches: {
            return createMatrixUsingRatioOfMismatches(params);
        }
        case MatrixCreationType.DissimilarityMatrixByManhattanDistance: {
            return createMatrixUsingDistance(params, type);
        }
        case MatrixCreationType.DissimilarityMatrixByEuclideanDistance: {
            return createMatrixUsingDistance(params, type);
        }
    }
};

export const createMatrixUsingDistance = (params: IMatrixCreationParameters, type: MatrixCreationType) : IMatrixCreationResult|null => {
    const matrix: (string|number)[][] = [];
    const calculations: string[] = [];

    const points = params.values;

    if(points.length === 0 || points[0].length === 0) return null;

    const rowsCount = points.length;

    for(let r=0; r<rowsCount; r++) {
        matrix.push([]);
    }

    for(let r1=0; r1<rowsCount; r1++) {
        const point1 = points[r1].map(val => Number(val));

        for(let r2=0; r2<rowsCount; r2++) {
            const point2 = points[r2].map(val => Number(val));

            const dots = `${ getPointString( point1 ) } - ${ getPointString( point2 ) }: `;

            if(type === MatrixCreationType.DissimilarityMatrixByManhattanDistance) {
                matrix[r1][r2] = manhattanDistance(point1, point2);
                calculations.push(dots + manhattanDistanceExplanation(point1, point2));
            }
            else{
                matrix[r1][r2] = euclideanDistance(point1, point2);
                calculations.push(dots + manhattanDistanceExplanation(point1, point2));
            }
        }
        calculations.push('---------------------------------------------------');
    }

    /*const newRowNames: string[] = [];
    for(let r=0; r<rowsCount; r++) {
        newRowNames.push((r + 1).toString());
    }*/

    return {
        matrix,
        rowNames: params.rowNames,
        calculations,
    };
};

export const createMatrixUsingRatioOfMismatches = (params: IMatrixCreationParameters) : IMatrixCreationResult|null => {
    const matrix: (string|number)[][] = [];

    if(params.values.length === 0 || params.values[0].length === 0) return null;

    const calculations: string[] = [];
    const columnsCount = params.values[0].length;
    const rowsCount = params.values.length;

    for(let r=0; r<rowsCount; r++) {
        matrix.push([]);
    }

    for(let r1=0; r1<rowsCount; r1++) {

        calculations.push(`Row ${ r1 + 1 }:`)

        for(let r2=0; r2<rowsCount; r2++) {

            let similarCount = 0;

            for(let c=0; c<columnsCount; c++) {
                if(params.values[r1][c].toString() === params.values[r2][c].toString()) {
                    similarCount++;
                }
            }

            const ratioOfMismatches = (columnsCount - similarCount) / columnsCount;
            matrix[r1][r2] = ratioOfMismatches;
            calculations.push(`(${ columnsCount } - ${ similarCount }) / ${ columnsCount } = ${ ratioOfMismatches }`);
        }
        calculations.push('---------------------------------------------------');
    }

    const newRowNames: string[] = [];
    for(let r=0; r<rowsCount; r++) {
        newRowNames.push((r + 1).toString());
    }

    return {
        matrix,
        rowNames: newRowNames,
        calculations,
    };
};